import i18n from ".";
import { LABELLED_ENUMS } from "../DTOs/apiEnums.generated";

type Labelled = typeof LABELLED_ENUMS;

export type LabelledEnum = keyof Labelled;

export type LabelledValue<T extends LabelledEnum> = Labelled[T][Exclude<keyof Labelled[T], number>];

const camel = (name: string) => name.charAt(0).toLowerCase() + name.slice(1);

const memberOf = (type: LabelledEnum, value: unknown) => {
  const members = LABELLED_ENUMS[type] as Record<string | number, string | number>;
  if (typeof value === "string") return value in members ? value : undefined;
  const member = members[value as number];
  return typeof member === "string" ? member : undefined;
};

export const enumLabel = <T extends LabelledEnum>(type: T, value: LabelledValue<T> | null | undefined): string => {
  if (value == null) return "";
  const member = memberOf(type, value);
  return member ? i18n.t(`enums.${camel(type)}.${camel(member)}`, { ns: "server", defaultValue: member }) : String(value);
};

export const enumValues = <T extends LabelledEnum>(type: T): LabelledValue<T>[] =>
  Object.values(LABELLED_ENUMS[type]).filter(value => typeof value === "number") as LabelledValue<T>[];
